<div class="rr-text-field {{ settings.class }}" #rrTextFieldContainer>
  <div class="form-group">
    <input
      required
      id="input{{ settings.fieldName | titlecase }}"
      name="input{{ settings.fieldName | titlecase }}"
      [type]="settings.type ? settings.type : 'text'"
      class="{{ control && !!control.invalid ? 'ng-invalid' : 'ng-valid' }}"
      [placeholder]="settings.placeholder ? settings.placeholder : ''"
      [disabled]="disabled"
      [tooltip]="settings.tooltip"
      [autofocus]="settings.autofocus"
      [(ngModel)]="data"
      (ngModelChange)="onChange($event)"
      (blur)="onTouched()"
    />
    <rr-info-icon
      *ngIf="settings.showInfoIcon"
      [className]="iconClassName"
      [tooltipText]="settings.infoIconTooltip"
    >
    </rr-info-icon>
    <label
      *ngIf="settings.label"
      for="input-{{ settings.fieldName.toString() | titlecase }}"
      >{{ settings.label }}
    </label>
    <div>
      <button
        type="button"
        class=""
        *ngIf="!settings.hideResetInput && !disabled"
        tabindex="-1"
        (click)="onClearInput()"
        [disabled]="disabled"
      >
        <span class="oi oi-x"></span>
      </button>
    </div>
  </div>
  <div class="error-message" *ngIf="showError">
    {{ errors[0] }}
  </div>
</div>
